module.exports = __webpack_public_path__ + "assets/5af5cbffb399bf9527275af2f9baf77a.png";